import { GoalAccountStructure } from '../../graphql/generated';

export type PartnerContributionOption = '50/50' | 'income' | 'joint';

export const DEFAULT_PARTNER_CONTRIBUTION_OPTION: Record<
    GoalAccountStructure,
    PartnerContributionOption | null
> = {
    JOINT: 'joint',
    SPLIT: '50/50',
    PRIVATE: null,
};

export const buildPartnerContributionOptions = (
    accountStructure: GoalAccountStructure
) => {
    let partnerContributionOptions: {
        label: string;
        value: PartnerContributionOption;
    }[] = [
        {
            label: 'My partner matches 50/50',
            value: '50/50',
        },
        {
            label: 'My partner matches by income',
            value: 'income',
        },
    ];

    if (accountStructure === 'JOINT') {
        partnerContributionOptions = [
            {
                label: 'We deposit from a joint account',
                value: 'joint',
            },
            ...partnerContributionOptions,
        ];
    }

    return partnerContributionOptions;
};
